<template>
  <b-card class="mb-2">
    <h5 class="mb-2">Laboratorio</h5>

    <!-- BUSCADOR (como en obj2/obj3) -->
    <div class="d-flex align-items-center">
      <v-select
        :options="opciones"
        :reduce="o => o"
        label="label"
        :filterable="true"
        :clearable="true"
        :searchable="true"
        :placeholder="'Buscar examen por nombre'"
        v-model="seleccion"
        @search="onSearch"
        class="flex-grow-1"
      />
      <b-button
        variant="warning"
        class="ml-2"
        title="add"
        @click="pushPrevio"
      >+</b-button>
    </div>

    <!-- LISTADO PREVIO (obj3) -->
    <b-card class="mt-2" bg-variant="light" v-if="previos.length">
      <h6 class="mb-2">Listado Previo de Exámenes a Enviar</h6>
      <div class="d-flex flex-wrap">
        <b-badge
          v-for="(p, idx) in previos"
          :key="p.codigo+'-'+idx"
          class="mr-2 mb-2 p-2"
          variant="secondary"
        >
          {{ p.label }}
          <b-button
            size="sm"
            variant="danger"
            class="ml-2 py-0 px-2"
            @click="removePrevio(idx)"
            title="Quitar"
          >x</b-button>
        </b-badge>
      </div>
    </b-card>

    <!-- CTA +AGREGAR (obj4) -->
    <div class="d-flex justify-content-end mt-2">
      <b-button
        variant="primary"
        size="sm"
        :disabled="!previos.length"
        @click="commitPrevios"
      >+ Agregar</b-button>
    </div>

    <!-- TARJETA RESULTADO (obj5) -->
    <b-alert
      v-if="itemsLocal.length"
      variant="info"
      class="mt-2"
      show
    >
      <div class="d-flex justify-content-between">
        <div>
          <div><strong>Estado:</strong> -</div>
          <div><strong>Código:</strong> {{ codigoTemporal }}</div>
          <div>
            <strong>Laboratorios:</strong>
            <span v-for="(it, i) in itemsLocal" :key="i">
              {{ it.label }}<span v-if="i < itemsLocal.length - 1">, </span>
            </span>
          </div>
        </div>
        <div class="text-right" style="min-width: 110px">
          <small class="text-muted">POR CREAR</small>
          <div class="mt-1">
            <b-button size="sm" variant="warning" class="mr-1" @click="editarTodo" title="Editar">
              <i class="fas fa-pen"></i>
            </b-button>
            <b-button size="sm" variant="danger" @click="borrarTodo" title="Eliminar">
              <i class="fas fa-times"></i>
            </b-button>
          </div>
        </div>
      </div>
    </b-alert>

    <!-- Aviso "no hay" -->
    <b-alert v-else variant="danger" class="mt-2" show>
      <i class="fa-solid fa-triangle-exclamation mr-1"></i>
      No ha registrado ningún examen
    </b-alert>
  </b-card>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'PaqLaboratorio',
  components: { vSelect },
  props: {
    // Lista final (la que guarda el paquete)
    items: {
      type: Array,
      default: () => [],
    },
    // Función de búsqueda opcional (q:string)=>Promise<[{codigo, descripcion}]>
    buscar: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      seleccion: null,       // opción seleccionada en el v-select
      opciones: [],          // opciones de búsqueda
      previos: [],           // listado previo (chips)
      itemsLocal: [...this.items], // espejo local de items finales
      codigoTemporal: String(Date.now()) // solo visual
    }
  },
  watch: {
    // Sincroniza con padre cuando cambie itemsLocal
    itemsLocal: {
      handler (val) {
        this.$emit('update:items', val)
      },
      deep: true
    }
  },
  methods: {
    async onSearch (q) {
      if (!this.buscar) {
        // modo sin backend (demo): devuelve ejemplos
        if (!q || q.length < 3) { this.opciones = []; return }
        this.opciones = Array.from({ length: 6 }).map((_, i) => ({
          codigo: `${360000 + i}`,
          descripcion: `${q.toUpperCase()} ${i + 1}`,
          label: `(${360000 + i}) ${q.toUpperCase()} ${i + 1}`
        }))
        return
      }
      const rs = await this.buscar(q)
      this.opciones = (rs || []).map(x => ({
        codigo: x.codigo,
        descripcion: x.descripcion,
        label: `(${x.codigo}) ${x.descripcion}`
      }))
    },
    pushPrevio () {
      if (!this.seleccion) return
      const exists = this.previos.some(p => p.codigo === this.seleccion.codigo)
      if (!exists) this.previos.push({ ...this.seleccion })
      this.seleccion = null
    },
    removePrevio (idx) {
      this.previos.splice(idx, 1)
    },
    commitPrevios () {
      if (!this.previos.length) return
      // En paquetes solo necesitamos {codigo, descripcion, cantidad}
      const normalizados = this.previos.map(p => ({
        codigo: p.codigo,
        descripcion: p.descripcion,
        cantidad: 1,
        label: p.label
      }))
      this.itemsLocal = [...this.itemsLocal, ...normalizados]
      this.previos = []
    },
    editarTodo () {
      // aquí puedes abrir un modal si luego quieres editar cantidades / notas
      this.$bvToast && this.$bvToast.toast('Editar (demo)', { variant: 'info' })
    },
    borrarTodo () {
      this.itemsLocal = []
    }
  }
}
</script>
